import React, { useContext, useEffect } from 'react'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { contactAtom } from 'pages/Contacts/atoms/contactAtoms'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { Contact } from 'types/contacts'
import { PaymentLinkStep } from 'types/payments'
import { ContactsSearch } from '../../../components/Contacts/ContactsSearch'
import { paymentLinkStepAtom } from './atoms/atoms'
import { PaymentLinkComplete } from './PaymentLinkComplete'
import { PaymentLinkDetails } from './PaymentLinkDetails'

const paymentLinkSteps = [
  PaymentLinkStep.CONTACT,
  PaymentLinkStep.DETAILS,
  PaymentLinkStep.COMPLETE,
] as const

export const PaymentLink = () => {
  const { t } = useTranslation()
  const step = useAtomValue(paymentLinkStepAtom)
  const [paymentLinkStep, setPaymentLinkStep] = useAtom(paymentLinkStepAtom)
  const [walletAction, setWalletAction] = useContext(WalletActionContext)
  const setContact = useSetAtom(contactAtom)

  const isFormSteps =
    paymentLinkStep !== PaymentLinkStep.COMPLETE && paymentLinkStep !== PaymentLinkStep.CONTACT

  const getSheetHeader = (): string => {
    switch (paymentLinkStep) {
      case PaymentLinkStep.CONTACT:
        return t('payments.paymentLinks.contactStepHeader')
      case PaymentLinkStep.DETAILS:
        return t('payments.paymentLinks.detailsStepHeader')
      default:
        return ''
    }
  }

  const handleContactSelect = (contact: Contact) => {
    setContact(contact)
    setPaymentLinkStep(PaymentLinkStep.DETAILS)
  }

  const handleOnBack = () => {
    const currentStepIndex = paymentLinkSteps?.indexOf(paymentLinkStep)
    setPaymentLinkStep(paymentLinkSteps[currentStepIndex - 1])
    setContact(null)
  }

  useEffect(() => {
    setWalletAction({
      ...walletAction,
      header: getSheetHeader(),
      onBack: isFormSteps ? handleOnBack : null,
      meta: {
        ...walletAction?.meta,
        handleContactSelect,
      },
    })
  }, [paymentLinkStep])

  return (
    <Box width="full">
      {step === PaymentLinkStep.CONTACT && <ContactsSearch />}
      {step === PaymentLinkStep.DETAILS && <PaymentLinkDetails />}
      {step === PaymentLinkStep.COMPLETE && <PaymentLinkComplete />}
    </Box>
  )
}
